import css from "./Membro.module.css";

function Membro(props) {
    return (
        <div className={`${css.membro} m-5`}>
            <p className={css.nome}>{props.nome}</p>

            <div className={css.membroformat}>
                <div className={`${css.membrodesc} d-flex flex-column gap-3`}>
                    <h3>{props.crf}</h3>
                    <p>{props.descmembro}</p>
                </div>

                <div className={css.membroimgcontainer}>
                    {/* Fixed: div syntax and closing tag */}
                    <div
                        className={css.membroimg}
                        style={{ backgroundImage: `url(${props.img})` }}
                    />
                </div>
            </div>
        </div>
    );
}

export default Membro;